import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconVerifiedBadgeSvg } from "./IconVerifiedBadgeSvg.mjs";
const IconVerifiedBadge = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconVerifiedBadgeSvg, ...iconProps });
};
export {
  IconVerifiedBadge
};
